// extracted by mini-css-extract-plugin
module.exports = {"popupWrapper":"popup-generator-module--popupWrapper--26NI_","overlay":"popup-generator-module--overlay--fawD2","iconWrapper":"popup-generator-module--iconWrapper--yPTaO"};